import { useEffect, useState } from 'react';
import { filters as filtersApi } from '@afosto/order/api/Filters';

const useOrderFilters = () => {
  const [additionalFilters, setAdditionalFilters] = useState([]);
  const [additionalProperties, setAdditionalProperties] = useState([]);
  const [isFetchingOrderFilters, setIsFetchingOrderFilters] = useState(true);

  useEffect(() => {
    const fetchOrderFilters = async () => {
      try {
        setIsFetchingOrderFilters(true);

        const response = await filtersApi.getFilterKeys();
        const { data = [] } = response;

        const formattedFilters = data.reduce(
          (acc, filter) => [
            ...acc,
            {
              key: filter,
              name: filter,
              operators: ['in'],
            },
          ],
          [],
        );

        const formattedProperties = data.reduce(
          (acc, filter) => [
            ...acc,
            {
              key: `filter_${filter}`,
              name: filter,
            },
          ],
          [],
        );

        setAdditionalFilters(formattedFilters);
        setAdditionalProperties(formattedProperties);
      } catch (err) {
        setAdditionalFilters([]);
        setAdditionalProperties([]);
      } finally {
        setIsFetchingOrderFilters(false);
      }
    };

    fetchOrderFilters();
  }, []);

  return [additionalFilters, additionalProperties, isFetchingOrderFilters];
};

export default useOrderFilters;
